import * as React from "react";
import {useMemo} from "react";
import {Alert, Col, Container, Row} from "react-bootstrap";
import {FaCircleInfo} from "react-icons/fa6";
import {useEmployeeNotificationBanner} from "../hooks/useEmployeeNotificationBanner";
import {identity} from "../utils/helpers";
import {useProductDetailsQuery} from "../hooks/useProductDetailsQuery";
import {EmployeeNotificationBannerModel} from "../models/view/employeeNotificationBannerModel";

export const EmployeeNotificationBanner = () => {
    const {isInternalUser} = identity();
    const {model: {isOnline, validated, stockInformation}} = useProductDetailsQuery();

    const isExternalRedirect = useMemo(() => {
        if (!isOnline) return true;
        if (!validated) return true;
        if (!stockInformation) return false;
        return !stockInformation.hasValidStatus;
    }, [isOnline, validated, stockInformation]);

    if (isInternalUser && isExternalRedirect)
        return <Content model={new EmployeeNotificationBannerModel(isOnline, validated, stockInformation)}/>

    return <></>;
}

const Content = ({model: {isOnline, validated, hasValidStatus}}: { model: EmployeeNotificationBannerModel }) => {
    const {productId, primaryId, isVariantProduct, show, onClose} = useEmployeeNotificationBanner();
    return (
        <Container fluid className="mt-3">
            <Row>
                <Col>
                    <Alert show={show} onClose={onClose} dismissible>
                        <Alert.Heading>
                            <FaCircleInfo className="me-1"/>
                            Internal Notification:
                        </Alert.Heading>
                        <p>External users would have been served a 404 page or redirected.</p>
                        <hr/>
                        <ol>
                            <li title={isVariantProduct ? `Both variant ${productId} and primary ${primaryId} need to be online.` : undefined}>
                                <p>
                                    <strong>Is Online:</strong>
                                    <span className={`ms-1 ${mapClassName(isOnline)}`}>
                                        {mapBoolToString(isOnline)}
                                    </span>
                                </p>
                            </li>
                            <li title={isVariantProduct ? `Both variant ${productId} and primary ${primaryId} need to be online.` : undefined}>
                                <p>
                                    <strong>Validated:</strong>
                                    <span className={`ms-1 ${mapClassName(validated)}`}>
                                        {mapBoolToString(validated)}
                                    </span>
                                </p>
                            </li>
                            <li title={hasValidStatus ? undefined : 'If the status is not null, whitespace or _blank_, then it is valid.'}>
                                <p>
                                    <strong>Has Valid Status:</strong>
                                    <span className={`ms-1 ${mapClassName(hasValidStatus)}`}>
                                        <span className={mapClassName(hasValidStatus)}>
                                            {mapBoolToString(hasValidStatus)}
                                        </span>
                                    </span>
                                </p>
                            </li>
                        </ol>
                    </Alert>
                </Col>
            </Row>
        </Container>
    )
}

const mapBoolToString = (value: boolean) => value ? "Yes" : "No";

const mapClassName = (value: boolean) => value ? "text-success" : "text-danger";